import { notification } from "antd";
import { FaRegTimesCircle } from "react-icons/fa";
import "./NotificaValidazioneFallita.css";

const notifyValidationError = (title: string, messages: Array<string>) => {
	notification["error"]({
		key:new Date().toDateString(),
		closeIcon:<><FaRegTimesCircle></FaRegTimesCircle>		</>,
		message: title,
		description: messages.map((message,i) => {
			return <div key={`error-notification-${i}`}>{message}</div>;
		}),
		placement: "bottomLeft",
		duration: 5,
		className: "notifyValidationError",icon:<></>
	
	});
};

export { notifyValidationError };

